<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper login">
            <h1 class="title-nobkg text-center"><b>{{$t('label_indirizzo_consegna')}}</b></h1><br>
            <div class="content text-center">
                <p>{{$t('msg_inserisci_indirizzo')}}</p>
                <div class="form-group">
                    <label class="text-aqua">{{$t('label_indirizzo_consegna')}}</label>
                    <inc-autocomplete
                        @onAddressPick="onAddressPick"
                        :address="this.address"
                        :house-number="this.house_number"
                        :address-error="this.address_error"
                        :number-error="this.number_error"
                    />
                </div>
                <div class="form-group" v-if="this.user.api_key">
                    <label class="text-aqua">{{$t('label_indirizzo_salvato')}}</label>
                    <select class="form-control" @change="onUserAddressChange">
                        <option :value="null" :selected="user_address_id === null">{{$t('select')}}</option>
                        <option v-for="address in this.addresses" :value="address.id"
                                :selected="user_address_id === address.id">
                            {{address.indirizzo}}, {{address.numero}}, {{address.cap_citta}} {{address.localita_citta}}
                            {{address.provincia}}, {{address.nazione}}
                        </option>
                    </select>
                </div>
                <p class="text-danger" v-if="this.address && !this.rooms_id.length">
                    {{$t('msg_nussun_ristorante')}}
                </p>
                <div class="d-flex justify-content-between">
                    <button v-if="!!$route.query.canGoBack" class="btn btn-default btn-sm mt-3" @click="$router.go(-1)">
                        « {{$t('btn_indietro')}}
                    </button>
                    <button class="btn btn-primary btn-sm mt-3" @click="onProceedPress"
                            :disabled="!this.rooms_id.length">
                        {{$t('prosegui')}} »
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

import IncAutocomplete from "../partials/IncAutocomplete";

import {buildAddressFromGeoResult, getGeoComponent, trovaConsegneCitta} from "../../libraries/utils";
import {geocode} from "../../api/mixed";
import {getMixedInfo} from "../../api/restaurant";
import {getDeliveryAddresses} from "../../api/account";

export default {
    name: "AddressSelect",
    components: {IncAutocomplete},
    data() {
        return {
            cities: null,
            addresses: null,

            place: null,
            address: null,
            house_number: null,
            number_error: false,
            address_error: false,
            user_address_id: null,
        }
    },
    created() {
        this.fetchInfo();
    },
    computed: {
        rooms_id: function () {
            if (this.cities && this.cities.length) {
                let lat = 0;
                let lng = 0;

                if (this.addresses && this.user_address_id) {
                    const address = this.addresses.find(
                        (address) => address.id === this.user_address_id,
                    );

                    if (address) {
                        lat = address.latitudine;
                        lng = address.longitudine;
                    }
                } else if (this.place) {
                    lat = typeof this.place.geometry.location.lat === "function" ? this.place.geometry.location.lat() : this.place.geometry.location.lat;
                    lng = typeof this.place.geometry.location.lng === "function" ? this.place.geometry.location.lng() : this.place.geometry.location.lng;
                }

                const consegneCitta = trovaConsegneCitta(this.cities, lng, lat);

                return [
                    ...new Set(consegneCitta.map((city) => city.consegnaCitta.id_locale)),
                ];
            }

            return [];
        },
        address_obj: function () {
            let formattedAddress,
                lat,
                lng,
                numeroCivico,
                indirizzo,
                citta,
                cap,
                provincia,
                nazione,
                id;

            if (this.user_address_id) {
                const address = this.addresses.find(
                    (address) => address.id === this.user_address_id,
                );

                if (address) {
                    formattedAddress = `${address.indirizzo}, ${address.numero}, ${address.cap_citta} ${address.localita_citta} ${address.provincia}, ${address.nazione}`;
                    lat = address.latitudine;
                    lng = address.longitudine;
                    numeroCivico = address.numero;
                    indirizzo = address.indirizzo;
                    citta = address.localita_citta;
                    cap = address.cap_citta;
                    provincia = address.provincia;
                    nazione = address.nazione;
                    id = address.id;
                }
            } else if (this.place) {
                formattedAddress = this.place.formatted_address;
                lat = this.place.geometry.location.lat;
                lng = this.place.geometry.location.lng;
                numeroCivico = getGeoComponent(this.place, 'street_number');
                indirizzo = getGeoComponent(this.place, 'route');
                citta = getGeoComponent(this.place, 'administrative_area_level_3');
                cap = getGeoComponent(this.place, 'postal_code');
                provincia = getGeoComponent(
                    this.place,
                    'administrative_area_level_2',
                    'short_name',
                );
                nazione = getGeoComponent(this.place, 'country', 'short_name');
                id = null;
            }

            return {
                tipo: 'COORDINATE',
                formatted_address: formattedAddress,
                lat: lat,
                lng: lng,
                numero_civico: numeroCivico,
                id_consegna_citta: null,
                id: id,
                info: {
                    indirizzo: indirizzo,
                    numero: numeroCivico,
                    localita_citta: citta,
                    cap_citta: cap,
                    provincia: provincia,
                    nazione: nazione,
                },
                completed: true,
            };
        },
        ...mapState('localization', {
            language: 'language'
        }),
        ...mapState('restaurant', {
            restaurant_id: state => state.id
        }),
        ...mapState('auth', {
            user: state => state
        })
    },
    methods: {
        fetchInfo: async function () {
            try {
                const response = await getMixedInfo(this.language, {
                    id_ristorante: this.restaurant_id,
                    consegne_citta: true
                });

                this.cities = response.consegne_citta.map((city) => {
                    return {
                        ...city,
                        coordinate: JSON.parse(city.coordinate)
                    }
                });

                if (this.user.api_key) {
                    const response = await getDeliveryAddresses(this.language, {
                        id_ristorante: this.restaurant_id,
                        api_key: this.user.api_key,
                        tipo_modalita_zone: 'COORDINATE'
                    });

                    this.addresses = response.indirizzi;
                }
            } catch (e) {
                alert(e);
            }
        },
        onAddressPick: function (place, address, number) {
            this.place = place;
            this.address = address;
            this.house_number = number;

            this.user_address_id = null;
        },
        onUserAddressChange: function (e) {
            this.user_address_id = e.target.value ? Number(e.target.value) : null;
            this.address = null;
            this.place = null;
            this.house_number = null;
        },
        goToRestautantSelection: function () {
            this.$router.push({
                name: 'rooms',
                query: {
                    canGoBack: this.$route.query.canGoBack,
                    service: this.$route.query.service,
                    rooms_id: this.rooms_id
                },
                params: {
                    cities: trovaConsegneCitta(this.cities, this.address_obj.lng, this.address_obj.lat),
                    address: this.address_obj
                }
            });
        },
        onProceedPress: async function () {
            this.number_error = false;
            this.address_error = false;

            if (this.user_address_id) {
                this.goToRestautantSelection();
            } else {
                try {
                    const response = await geocode(this.language, {
                        address: buildAddressFromGeoResult(this.place, this.house_number)
                    });

                    if (response.results.length) {
                        const geocodeResult = response.results[0];

                        let postal_code = geocodeResult.address_components.find(
                            (address_component) => {
                                return address_component.types.includes('postal_code');
                            },
                        );

                        let streetNumber = geocodeResult.address_components.find(
                            (address_component) => {
                                return address_component.types.includes('street_number');
                            },
                        );

                        if (postal_code && streetNumber) {
                            this.house_number = null;
                            this.address = geocodeResult.formatted_address;
                            this.place = geocodeResult;

                            if (this.rooms_id.length) {
                                this.goToRestautantSelection();
                            }
                        } else {
                            if (!postal_code) {
                                this.address_error = true;
                            }
                            if (!streetNumber) {
                                this.number_error = true;
                            }
                        }
                    }
                } catch (e) {
                    alert(e);
                }
            }
        }
    },
}
</script>
